import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    addCareer,
    getCareers,
    getCareer,
    editCareer,
    deleteCareer,
    getAllCareers,
} from "../../store/actions/career_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllCareers = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.career);
    const [pageNumber, setPageNumber] = useState(1);
    const [deleteEntry, setDeleteEntry] = useState(null);

    useEffect(() => {
        if (deleteEntry) {
            dispatch(deleteCareer(deleteEntry));
        }
        allQuery();
    }, [deleteEntry, pageNumber, window.location.search]);
    const allQuery = useCallback(
        _debounce(() => {
            dispatch(getCareers({}));
        }, 1000),
        []
    );

    const deleteBtnClicked = async (id) => {
        setDeleteEntry(id);
    };

    return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleCareer = (id) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.career);
    useEffect(() => {
        dispatch(getCareer(id));
    }, [id]);
    return [data];
};
// Add Data
export const useCreateCareer = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.career);
    const addData = async (data) => {
        await dispatch(addCareer(data));
    };
    return [data, addData];
};
export const useUpdateCareer = () => {
    const dispatch = useDispatch();
    // const data = useSelector((state) => state.career);
    const updateData = async (id, data) => {
        await dispatch(editCareer(id, data));
    };
    return [updateData];
};

export const useSelectAllCareer = () => {
    const dispatch = useDispatch();
    const [term, setTerm] = useState("");
    const [value, setValue] = useState("");
    const data = useSelector((state) => state.career);
    useEffect(() => {
        dispatch(getAllCareers({ term, value }));
    }, [term, value]);
    return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
    //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();

    const [dropdownOptions, setDropdownOptions] = useState({});
    // useEffect(() => {
    //   if (industry && industry.all_industrys) {
    //     const newData = industry.all_industrys.map((item) => {
    //       return { label: item.name, value: item.name };
    //     });
    //     setDropdownOptions({ ...dropdownOptions, industry: newData });
    //   }
    // }, [industry]);
    const loadOptions = async (inputValue, callback, field) => {
        // if (field == "parent_category") {
        //   await setCategorySearchField("name");
        //   await setCategorySearchValue(inputValue);
        //   callback(dropdownOptions.parent_category);
        // }
    };

    return [dropdownOptions, loadOptions];
};
